import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export const useReturn = (route?: string): (() => void) => {
  const history = useHistory();

  return useCallback(() => {
    if (route) {
      history.replace(route);
    } else {
      history.goBack();
    }
  }, [route, history]);
};
